import React, { useContext, useEffect, useState } from "react";
import classes from "./LoginPage.module.css"
import { backend_routes } from "../../../common/links";
import { AuthContext } from "../../../context/authContext";
import MyLoadingIcon from "../../UI/loadingIcon/MyLoadingIcon";
import MyInput from "../../UI/input/MyInput";
import MyButton from "../../UI/button/MyButton"
import { useAxiosPostRefreshing } from "../../../hooks/useAxios";

const LoginPage = function(){
    const {isAuthenticated, setIsAuthenticated, isLoading} = useContext(AuthContext);
    const [loginValue, setLoginValue] = useState('');
    const [passwordValue, setPasswordValue] = useState('');
    const [authBody, setAuthBody] = useState({
        data:{
            login: loginValue,
            password: passwordValue
        },
        device: {
            model: "",
            app_version: "",
            system: "web",
            firebase_token: ""}});
    const changeLogin = function(event){setLoginValue(event.target.value);}
    const changePassword = function(event){setPasswordValue(event.target.value);}
    useEffect(()=>{
        let data = {
            login: loginValue,
            password: passwordValue
        }
        setAuthBody({...authBody, data});
    },[loginValue, passwordValue]);
        
    useEffect(()=>{
        if (localStorage.getItem("accessToken")){
            setIsAuthenticated(true);
        }
        else setIsAuthenticated(false);
    },[]);

    const [postLogin, isLoginSending] = useAxiosPostRefreshing(
        function (response) {
            setIsAuthenticated(true);
            localStorage.setItem("accessToken", response.data.data.access_token);
            localStorage.setItem("refreshToken", response.data.data.refresh_token);
        }
    );


    const submit = async function (event) {
        event.preventDefault();
        postLogin(backend_routes.AUTH_LINK, authBody);
    }

    return(
        <div id="login_page" className={classes.loggingPage}>
            {!isLoginSending
                ?
                <form onSubmit={submit}>
                    <MyInput style={{marginBottom: "5px"}} type="text" placeholder='Введите логин' value={loginValue} onChange={event => changeLogin(event)}/>
                    <MyInput style={{ marginBottom: "5px" }} autoComplete="current-password" type="password" placeholder='Введите пароль' value={passwordValue} onChange={event => changePassword(event)} />
                    <MyButton type="submit">Войти</MyButton>
                </form>
                : <MyLoadingIcon/>
            }

        </div>
    );
}
export default LoginPage;